import React, { useContext, useEffect, useRef, useState } from 'react';
import './Billprint2.css';
import NotoSansKannada from "../../Fonts/NotoSansKannada.ttf";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { Document, Page, Text, View, StyleSheet, PDFViewer, Image } from '@react-pdf/renderer';
import { Font } from '@react-pdf/renderer';
import LatoItalicFont from "../../Fonts/Baloo2-VariableFont_wght.ttf";
import Logo from "../../imgs/dairylogo.png";
import { UilEditAlt, UilTrash } from '@iconscout/react-unicons'
import { lightGreen } from '@mui/material/colors';
import Globalcontext from '../../Context/Globalcontext';
import Cowsmall from "../../imgs/cowsmall.gif";
import Grass from "../../imgs/grass.png";
import { LanRounded } from '@mui/icons-material';
import { useTranslation } from "react-i18next";

// Register the font using the imported variable
Font.register({
    family: 'Lato-Italic',
    src: LatoItalicFont,
});

Font.register({
    family: "Kannada",
    src: NotoSansKannada,
});

const Billprint = (props) => {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState(0);
    const [customerData, setCustomerData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [loadedPages, setLoadedPages] = useState(1);
    let bothornotmain = "";


    const loadMorePages = () => {
        setIsLoading(true);
        const pagesToLoad = 1; // Change this to load more pages

        setTimeout(() => {
            setLoadedPages(loadedPages + pagesToLoad);
            setIsLoading(false);
        }, 1000);
    };

    useEffect(() => {
        console.log(localStorage.getItem("customerData"));
        setTimeout(() => {

            if (JSON.parse(localStorage.getItem("customerData"))) {
                setCustomerData(JSON.parse(localStorage.getItem("customerData")));
                // Set loading to false when data is ready
                setIsLoading(false);
            }
        }, 200);
    }, []);

    const pageDataLength = parseFloat(Object.keys(customerData).length) / 2;
    const minutes = Math.floor(pageDataLength / 60);
    const seconds = pageDataLength % 60;

    return (
        <div className="billprintmain">
            <PDFViewer className='pdf'>
                <Document>
                    {Object.keys(customerData).map((kno, index) => (
                        <PageTemplate key={index} data={customerData[kno]} index={index} kno={kno} min={minutes} sec={seconds} pages={parseFloat(pageDataLength) * 2} t={t} lang={i18n.language} />
                    ))}
                </Document>
            </PDFViewer>
        </div>
    );
};

function PageTemplate({ data, index, kno, min, sec, pages, t,lang }) {
    const fontBase = lang === "kn" ? "Kannada" : "Lato-Italic";
    const [kapat, setKapat] = useState({});
    const [isGenerating, setIsGenerating] = useState(true);

    const generatePageContent = async () => {
        // Simulate page generation
        await new Promise(resolve => setTimeout(resolve, 1000)); // Adjust the duration as per your page generation time
        setIsGenerating(false); // Set isGenerating to false when the page is ready
    };

    useEffect(() => {
        generatePageContent();
    }, []);


    const getDatesInRange = (date1, date2) => {
        const dates = [];
        const currentDate = new Date(date1);

        while (currentDate <= new Date(date2)) {
            dates.push(currentDate.toISOString().split('T')[0]);
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    };

    const getTableDataWithZeros = (tableData, date1, date2, type, time) => {
        if (!Array.isArray(tableData)) {
            return Array.from({ length: getDatesInRange(date1, date2).length }, (_, index) => ({
                sr: '',
                date: getDatesInRange(date1, date2)[index],
                time: time,
                kno: '',
                type: type,
                liter: '0',
                fat: '0',
                snf: '0',
                rate: '0',
                amt: '0.00',
                date1: date1,
                date2: date2,
                kendra: '',
            }));
        }

        const dateRange = getDatesInRange(date1, date2);
        const tableWithData = [];

        dateRange.forEach(date => {
            const matchingEntry = tableData.find(
                entry => entry.date === date && entry.type === type && entry.time === time
            );

            if (matchingEntry) {
                tableWithData.push(matchingEntry);
            } else {
                // Create a record with zero values
                tableWithData.push({
                    sr: '',
                    date: date,
                    time: time,
                    kno: '',
                    type: type,
                    liter: '0',
                    fat: '0',
                    snf: '0',
                    rate: '0',
                    amt: '0.00',
                    date1: date1,
                    date2: date2,
                    kendra: '',
                });
            }
        });

        return tableWithData;
    };


    const styles = StyleSheet.create({
        page: {
            paddingTop: 10,
            flexDirection: 'row',
            backgroundColor: '#FFFFFF',
            justifyContent: 'center', // Center horizontally
            marginLeft: 14, // Increase the left margin
            marginRight: 13

        },
        pageboth: {
            paddingTop: 10,
            flexDirection: 'row',
            backgroundColor: '#FFFFFF',
            justifyContent: 'center', // Center horizontally
            marginLeft: 4, // Increase the left margin
            marginRight: 13

        },
        pageWithMargin: {
            backgroundColor: "lightblue"
        },
        header: {
            position: 'absolute',
            top: 0, // Adjust this value to change the vertical position
            left: 0,
            right: 0,
            textAlign: 'center',
        },
        loading: {
            display: 'flex',
            flexDirection: 'column',
            width: '100vw',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center'
        },
        tableContainer: {
            flexDirection: 'row',
            width: '100%',           // ✅ don't use 100vw inside PDF
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
        },

        table: {
            display: 'table',
            width: 'auto', // Adjust as needed to fit four tables in a row
            margin: 5,
            marginLeft: -1,
        },
        // ✅ shrink "रक्कम" column a bit to make space
        tableone: {
            display: 'table',
            width: '22mm',     // ✅ was 28mm
            marginTop: 5,
            marginBottom: 5,
            marginRight: 0,
            marginLeft: 0,
        },

        tableoneLiter: {
            display: 'table',
            width: '16mm',      // ✅ small
            marginTop: 5,
            marginBottom: 5,
            marginRight: 0,
            marginLeft: 0,
        },
        tableCellone: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
        },
        tableCellonebig: {
            border: '0.5px solid lightgray',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold'
        },
        tableCellonebig2: {
            border: '0.5px solid #000',
            fontSize: 9.5,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '10px',
            width: '100%',
            fontWeight: 'bold'
        },
        tableCellonebigdata: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '3mm',
            width: '100%',
            fontWeight: 'bold'
        },
        tableRowone: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            textAlign: 'right',
            marginLeft: 0,
        },
        tableRowonebig: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            textAlign: 'right',
            marginLeft: 0,
        },
        tableHeaderone: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: 0,
            backgroundColor: 'lightgray'
        },
        tableHeaderonebig: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            textAlign: 'right',
            border: '0.5px solid #000',
            marginLeft: 0,
            backgroundColor: 'lightgray'
        },
        allbill: {
            flexDirection: 'row',
            width: '100%',
            textAlign: 'right',
            height: 17,
            marginLeft: 0,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        allbillbig: {
            border: '0.5px solid lightgray',
            flexDirection: 'row',
            width: '100%',
            textAlign: 'right',
            height: 17,
            marginLeft: 0,
            backgroundColor: 'lightgray',
            marginTop: 5
        },
        tableRow: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,

        },
        tableRow2: {
            flexDirection: 'row',
            height: 17,
            marginLeft: 3,
            marginTop: 5,
            backgroundColor: 'lightgray'
        },
        line: {
            flexDirection: 'row',
            backgroundColor: 'lightgray',
            height: 1,
            marginTop: 2,
            width: '95vw',
        },
        tableHeader: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '5mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersm: {
            border: '0.5px solid #000',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'center',
            paddingLeft: 1,
            paddingRight: 1,
            width: '6mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig2: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadersmbig3: {
            border: '0.5px solid #000',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '10mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermedbig: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '13mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '10mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableHeadermed2big: {
            border: '0.5px solid #000',
            padding: 0.5,
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '19mm', // Set the width of the individual cell
            backgroundColor: 'lightgray',
        },
        tableCell: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '1mm', // Set the width of the individual cell
        },
        tableCellsm: {
            border: '0.5px solid lightgray',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '6mm', // Set the width of the individual cell
        },
        tableCellsmamt: {
            border: '0.5px solid blue',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            width: '10mm', // Set the width of the individual cell

        },
        tableCellsmbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'center',
            width: '14mm', // Set the width of the individual cell

        },
        tableCellmed: {
            border: '0.5px solid lightgray',
            fontSize: 8,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '10mm', // Set the width of the individual cell
        },
        tableCellmedbig: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '13mm', // Set the width of the individual cell
        },
        tableCellmed2: {
            border: '0.5px solid lightgray',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '10mm', // Set the width of the individual cell
        },
        tableCellmed2big: {
            border: '0.5px solid lightgray',
            fontSize: 10,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: '1mm',
            width: '19mm', // Set the width of the individual cell
        },
        latoText: {
            fontFamily: fontBase,
            fontSize: 15,
            marginBottom: 5,
            textAlign: 'center',
            width: '100%',
            fontWeight: 'bold',
            marginLeft: -15,
            marginTop: 1,
        },
        headtextsmall: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
        },
        headtextsmall2: {
            fontFamily: fontBase,
            fontSize: 14,
            marginLeft: 20,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmall3: {
            fontFamily: fontBase,
            fontSize: 14,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmall4: {
            fontFamily: fontBase,
            fontSize: 10,
            color: 'rgb(156, 44, 24)',
            fontWeight: 'bold',
            alignSelf: 'center'
        },
        headtextsmallleft1: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft3: {
            fontFamily: fontBase,
            fontSize: 9,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft4: {
            fontFamily: fontBase,
            fontSize: 9,
            marginRight: -50,
            marginTop: -5,
            fontWeight: 'bold',
        },

        headtextsmallleft1big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: -70,
            marginTop: -5,
            fontWeight: 'bold',
        },
        headtextsmallleft2big: {
            fontFamily: fontBase,
            fontSize: 11,
            marginLeft: 0,
            marginTop: -5,
            fontWeight: 'bold',
        },

        row: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
        },
        row1: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 5
        },
        row2: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 140,
            paddingRight: 140,
            backgroundColor: 'lightgray',
        },
        row2both: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: 180,
            paddingRight: 180,
            backgroundColor: 'lightgray',
        },
        row2single: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingLeft: '250px',
            backgroundColor: 'lightgray',
        },
        column1: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
            border: '0.5px solid black',
        },
        column1noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '23%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 10,
        },
        column2: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5,
            border: '0.5px solid black',

        },
        column2noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            paddingLeft: 5,
            paddingRight: 5,
            marginLeft: 5
        },
        column3: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            border: '0.5px solid black',
            marginLeft: 7,
        },
        column3noborder: {
            display: 'flex',
            flexDirection: 'column',
            width: '15%',
            paddingLeft: 3,
            paddingRight: 3,
            justifyContent: 'start',
            alignItems: 'flex-start', // Align text to the left
            marginLeft: 7,
        },
        column1Row: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        column1Rowratib: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
        },
        column1Rowratib2: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: -5,
            marginBottom: 3
        },
        simplerow: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            width: '20%',
        },
        simplecol: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            marginTop: 0
        },
        column1Rowgray: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingLeft: 4,
            marginTop: 0,
            marginBottom: 1,
            border: '0.5px solid black',
            backgroundColor: 'lightgray'
        },
        column1Label: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'left', // Align labels to the left
        },
        column1Labelcenter2: {
            fontFamily: fontBase,
            fontSize: 10,
            fontWeight: 'bold',
            alignSelf: 'center',
            textAlign: 'center', // Align labels to the left
        },
        column1Value: {
            fontFamily: fontBase,
            fontSize: 9,
            fontWeight: 'bold',
            textAlign: 'right', // Align values to the right
        },
        pageBreak: {
            pageBreakBefore: 'always',
        },
        totalsRow: {
            flexDirection: 'row',
            borderTop: '1px solid #000',
            paddingTop: 5,
            paddingLeft: 2,
        },
        totalsCell: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 8,
            width: 2,
            textAlign: 'center',
        },
        imagerow: {
            display: 'flex',
            flexDirection: 'row',
            width: '95vw',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: -4
        },
        image: {
            width: 45, // Adjust the width as needed
            height: "auto", // Maintain aspect ratio
            marginLeft: -5,
            marginTop: 5

        },
        imgtext: {
            fontFamily: fontBase,
            fontSize: 8,
            fontWeight: 'bold',
            textAlign: 'center', // Align labels to the left
        },
        tableCellgreen: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'green',
            width: 2,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        tableCellred: {
            border: '0.5px solid lightgray',
            padding: 0.5,
            flex: 1,
            fontSize: 12,
            fontWeight: 'bold',
            fontFamily: fontBase,
            color: 'red',
            width: 3,
            fontWeight: 'bold',
            textAlign: 'center',
        },
        loadingSpinner: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: 16,
            fontWeight: 'bold',
            color: 'gray',
        },
        lastTwoWrap: {
            flexDirection: 'row',
            marginLeft: 6,      // small gap from previous tables
            flexShrink: 1,      // ✅ allow shrink if needed
        },



        // ✅ wrapper for last two columns
        lastTwoWrap: {
            flexDirection: 'row',
            marginLeft: 6,     // gap from previous tables
            flexShrink: 0,     // do not auto stretch
            alignSelf: 'flex-start',
        },

        // ✅ widths for summary columns (both vs single)
        summaryLiterBoth: { width: '10mm', marginTop: 5, marginBottom: 5, marginRight: 0, marginLeft: -6 },
        summaryAmtBoth: { width: '14mm', marginTop: 5, marginBottom: 5, marginRight: 0, marginLeft: 0 },

        summaryLiterSingle: { width: '18mm', marginTop: 5, marginBottom: 5, marginRight: 0, marginLeft: 0 },
        summaryAmtSingle: { width: '26mm', marginTop: 5, marginBottom: 5, marginRight: 0, marginLeft: 0 },

        // ✅ summary table row/header (same height as your tables)
        summaryHeaderRow: {
            flexDirection: 'row',
            width: '90%',
            height: 17,
            border: '0.5px solid #000',
            backgroundColor: 'lightgray',
        },
        summaryHeaderRowsingle: {
            flexDirection: 'row',
            width: '60%',
            height: 17,
            border: '0.5px solid #000',
            backgroundColor: 'lightgray',
        },
        summaryHeaderRowliter: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            border: '0.5px solid #000',
            backgroundColor: 'lightgray',
        },
        summaryDataRow: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
        },

        // ✅ cells must NOT have any fixed mm width
        summaryHeaderCell: {
            width: '100%',
            borderRight: '0.5px solid #000',
            fontSize: 8,
            fontFamily: fontBase,
            fontWeight: 'bold',
            textAlign: 'center',
            paddingTop: 2,
        },

        summaryDataCell: {
            width: '90%',
            border: '0.5px solid lightgray',
            fontSize: 7,
            color: 'black',
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 2,
            paddingTop: 2,
        },
        summaryDataCellsingle: {
            width: '60%',
            border: '0.5px solid lightgray',
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            paddingTop: 2,
        },
        summaryDataCellliter: {
            width: '100%',
            border: '0.5px solid lightgray',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            paddingTop: 2,
        },
        summaryDataCelllitersingle: {
            width: '100%',
            border: '0.5px solid lightgray',
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 3,
            paddingTop: 2,
        },
        summaryTotalRow: {
            flexDirection: 'row',
            width: '90%',
            height: 17,
            backgroundColor: 'lightgray',
            border: '0.5px solid lightgray',
            marginTop: 5,
        },
        summaryTotalRowsingle: {
            flexDirection: 'row',
            width: '60%',
            height: 17,
            backgroundColor: 'lightgray',
            border: '0.5px solid lightgray',
            marginTop: 5,
        },
        summaryTotalRowliter: {
            flexDirection: 'row',
            width: '100%',
            height: 17,
            backgroundColor: 'lightgray',
            border: '0.5px solid lightgray',
            marginTop: 5,
        },
        summaryTotalCell: {
            width: '100%',
            fontSize: 7,
            fontFamily: fontBase,
            textAlign: 'right',
            paddingRight: 4,
            fontWeight: 'bold',
        },
        summaryTotalCellsingle: {
            width: '100%',
            fontSize: 9,
            fontFamily: fontBase,
            textAlign: 'right',
            color: 'black',
            border: '0.5px solid #000',
            paddingRight: 4,
            fontWeight: 'bold',
        },


    });

    const knoData = data;
    const groupByTypeAndTime = {};

    let tlitermhmor = 0;
    let tlitermhevn = 0;
    let tlitergaymor = 0;
    let tlitergayevn = 0;

    // Group data by 'type' and 'time'
    knoData.forEach(entry => {
        const key = entry.type + '-' + entry.time;
        tlitermhmor = entry.tlitermhmor;
        tlitermhevn = entry.tlitermhevn;
        tlitergaymor = entry.tlitergaymor;
        tlitergayevn = entry.tlitergayevn;
        if (!groupByTypeAndTime[key]) {
            groupByTypeAndTime[key] = [];
        }
        groupByTypeAndTime[key].push(entry);
    });

    const tableDataArrays = ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey) => {
        const [type, time] = typeTimeKey.split('-');
        const entries = groupByTypeAndTime[typeTimeKey]; // You should define 'groupByTypeAndTime' based on your data structure.
        return getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);
    });

    function formatDate(inputDate) {
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Date(inputDate).toLocaleDateString('en-US', options);
    }


    const calculateSumOfAmtColumns = (tableDataArray) => {
        const sums = Array.from({ length: tableDataArray[0].length }, () => 0); // Initialize an array with zeros based on the length of the first table

        // Loop through the tables and calculate sums for each record
        tableDataArray.forEach((tableDataWithZeros) => {
            tableDataWithZeros.forEach((entry, entryIndex) => {
                sums[entryIndex] += parseFloat(entry.amt);
            });
        });
        return sums;
    };

    const sumsOfAmtColumns = calculateSumOfAmtColumns(tableDataArrays);
    //  console.log("sumsOfAmtColumns: ", sumsOfAmtColumns);
    const sumOfFifthTable = sumsOfAmtColumns.reduce((total, sum) => total + parseFloat(sum), 0).toFixed(2);

    // ✅ Liter sums column-wise (same as Amt)
    const calculateSumOfLiterColumns = (tableDataArray) => {
        const sums = Array.from({ length: tableDataArray[0].length }, () => 0);

        tableDataArray.forEach((tableDataWithZeros) => {
            tableDataWithZeros.forEach((entry, entryIndex) => {
                sums[entryIndex] += parseFloat(entry.liter || 0);
            });
        });

        return sums;
    };

    const sumsOfLiterColumns = calculateSumOfLiterColumns(tableDataArrays);
    const sumOfLiterTable = sumsOfLiterColumns
        .reduce((total, sum) => total + parseFloat(sum), 0)
        .toFixed(2);


    let totalOfTotalLiter = 0;
    let totalOfTotalFat = 0;
    let tkapat = 0;
    let tyene = 0;
    let ada = 0;

    let zeroflagmh = false;
    let zeroflaggay = false;

    let zeroflagmhevn = false;
    let zeroflaggayevn = false;

    let totalLiterMh = 0;
    let totalLiterGay = 0;

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [isboth, setIsboth] = useState(false);

    useEffect(() => {
        if (zeroflagmh && zeroflaggay) {
            //   console.log("in both");
            setIsboth(true);
        }
    }, [zeroflagmh, zeroflaggay]);

    const renderTable = (tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate) => {
        return (
            <View key={typeTimeKey} style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                    {tableIndex == dateflag ? (
                        <Text
                            style={[
                                bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig,
                                { width: bothornot === "both" ? 38 : 38 }
                            ]}
                        >
                            {t("billprint.table.date")}
                        </Text>
                    ) : null}

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint.table.liter")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint.table.fat")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadersm : styles.tableHeadersmbig}>
                        {t("billprint.table.snf")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed : styles.tableHeadersmbig2}>
                        {t("billprint.table.rate")}
                    </Text>

                    <Text style={bothornot === "both" ? styles.tableHeadermed2 : styles.tableHeadersmbig3}>
                        {t("billprint.table.amount")}
                    </Text>
                </View>
                {/* Table Data */}
                {tableDataWithZeros.map((entry, entryIndex) => (
                    <View key={entryIndex} style={styles.tableRow}>
                        {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                            <Text style={[bothornot === "both" ? styles.tableCell : styles.tableCellbig, { width: 38 }]}>
                                {entry.date.substr(5).split('-').reverse().join('/')}
                            </Text>
                        ) : null}
                        {
                            entry.liter === '0' ?
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}></Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}></Text>
                                </>
                                :
                                <>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.liter}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.fat}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellsm : styles.tableCellsmbig}>{entry.snf}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed : styles.tableCellmedbig}>{parseFloat(entry.rate).toFixed(2)}</Text>
                                    <Text style={bothornot === "both" ? styles.tableCellmed2 : styles.tableCellmed2big}>{parseFloat(entry.amt).toFixed(2)}</Text>
                                </>
                        }
                    </View>
                ))}
                {/* Totals Row */}
                <View style={styles.tableRow2}>
                    {tableIndex == dateflag ? ( // Render "दिनांक" only for the first table
                        <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig, { width: bothornot === "both" ? 35 : 39 }]}>एकूण</Text>
                    ) : null}
                    <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{totalLiter.toFixed(1)}</Text>
                    {
                        localStorage.getItem("avg") === "On" ?
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgfat ? avgfat.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{avgsnf ? avgsnf.toFixed(1) : "0.0"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellmed : styles.tableHeadersmbig2]}>{avgrate ? avgrate.toFixed(2) : "0.0"}</Text>

                            </>
                            :
                            <>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellsm : styles.tableHeadersmbig]}>{"-"}</Text>
                                <Text style={[bothornot === "both" ? styles.tableCellmed : styles.tableHeadersmbig2]}>{"-"}</Text>

                            </>
                    }
                    <Text style={[bothornot === "both" ? styles.tableCellmed2 : styles.tableHeadersmbig3]}>{totalAmt.toFixed(2)}</Text>
                </View>
            </View>
        );
    };

    let dateflag = "";
    let bothornot = "";
    let milktype = "";

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";
    }


    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "not";
        milktype = "Buffalo";
    }

    // Remaining combinations

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
        //

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 0;
        bothornot = "both";
    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";

    }

    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 0;
        bothornot = "both";

    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
        dateflag = 2;
        bothornot = "not";
        milktype = "Cow";
    }

    const getMilkTypeLabel = (type) => {
        if (!type) return "";
        const v = String(type).toLowerCase();
        if (v === "buffalo") return t("common.milkType.buffalo");
        if (v === "cow") return t("common.milkType.cow");
        return type; // fallback
    };

    return (
        <>
            <Page
                key={index}
                size={localStorage.getItem("dur") === "10" ? "A5" : "A4"}
                orientation={localStorage.getItem("dur") === "10" ? "landscape" : "portrait"}
                style={[
                    bothornot === "both" ? styles.pageboth : styles.page,
                    { fontFamily: fontBase }
                ]}
            >
                {isGenerating ? (
                    <View style={styles.loading}>
                        <Text style={styles.headtextsmall3}>
                            {t("billprint.loading.generating", {
                                min,
                                sec
                            })}
                        </Text>

                        <Text style={styles.headtextsmall4}>
                            {t("billprint.loading.totalPages", { pages })}
                        </Text>
                    </View>
                ) : (

                    <View>
                        <View style={styles.row1}>
                            <Text style={styles.headtextsmall}>
                                {`${t("billprint.account")}: ${kno} (${knoData[0].cname})`}
                            </Text>

                            <Text style={styles.headtextsmall2}>
                                {`${knoData[0].kendra},${localStorage.getItem("city")}`}
                            </Text>

                            <Text style={styles.headtextsmall}>
                                {`${t("billprint.period")} : ${formatDate(knoData[0].date1)}   ${t("common.to")}   ${formatDate(knoData[0].date2)}`}
                            </Text>
                        </View>

                        {
                            bothornot === "both" ?
                                <View>
                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmall}>{t("common.buffalo")}</Text>
                                        <Text style={styles.headtextsmall}>{t("common.cow")}</Text>
                                    </View>

                                    <View style={styles.row2}>
                                        <Text style={styles.headtextsmallleft1}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2}>{t("common.evening")}</Text>
                                        <Text style={styles.headtextsmallleft3}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft4}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                                :
                                <View>
                                    <View style={styles.row2single}>
                                        {/* milktype is "Buffalo"/"Cow" from server/UI.
           If it can be English values, translate it safely: */}
                                        <Text style={styles.headtextsmall}>
                                            {milktype === "Buffalo" ? t("common.buffalo") : milktype === "Cow" ? t("common.cow") : milktype}
                                        </Text>
                                    </View>

                                    <View style={styles.row2both}>
                                        <Text style={styles.headtextsmallleft1big}>{t("common.morning")}</Text>
                                        <Text style={styles.headtextsmallleft2big}>{t("common.evening")}</Text>
                                    </View>
                                </View>
                        }

                        <View style={styles.tableContainer}>
                            {
                                ['Buffalo-Morning', 'Buffalo-Evening', 'Cow-Morning', 'Cow-Evening'].map((typeTimeKey, tableIndex) => {
                                    const [type, time] = typeTimeKey.split('-'); // Split type and time
                                    const entries = groupByTypeAndTime[typeTimeKey];
                                    const tableDataWithZeros = getTableDataWithZeros(entries, knoData[0].date1, knoData[0].date2, type, time);

                                    // Calculate totals
                                    const totalLiter = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.liter), 0);
                                    totalOfTotalLiter += totalLiter;


                                    const totalFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.fat), 0); // Sum up the fat values

                                    const totalEntriesWithFat = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgfat = totalFat / totalEntriesWithFat;

                                    const totalSNF = tableDataWithZeros
                                        .filter(entry => entry.fat > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.snf), 0); // Sum up the fat values

                                    const totalEntriesWithSNF = tableDataWithZeros
                                        .filter(entry => entry.snf > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgsnf = totalSNF / totalEntriesWithSNF;

                                    const totalRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .reduce((total, entry) => total + parseFloat(entry.rate), 0); // Sum up the fat values

                                    const totalEntriesWithRate = tableDataWithZeros
                                        .filter(entry => entry.rate > 0) // Filter entries where fat is greater than 0
                                        .length;

                                    const avgrate = totalRate / totalEntriesWithRate;


                                    // tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0) + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0) + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0) + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) 
                                    tkapat = parseFloat(knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0)
                                        + parseFloat(knoData[0].cthevitr1 !== null && !isNaN(knoData[0].cthevitr1) ? knoData[0].cthevitr1 : 0)
                                        + parseFloat(knoData[0].cthevitr2 !== null && !isNaN(knoData[0].cthevitr2) ? knoData[0].cthevitr2 : 0)
                                        + parseFloat(knoData[0].cthevitr3 !== null && !isNaN(knoData[0].cthevitr3) ? knoData[0].cthevitr3 : 0)
                                        + parseFloat(knoData[0].itrkapat1 !== null && !isNaN(knoData[0].itrkapat1) ? knoData[0].itrkapat1 : 0)
                                        + parseFloat(knoData[0].itrkapat2 !== null && !isNaN(knoData[0].itrkapat2) ? knoData[0].itrkapat2 : 0)
                                        + parseFloat(knoData[0].itrkapat3 !== null && !isNaN(knoData[0].itrkapat3) ? knoData[0].itrkapat3 : 0)
                                        + parseFloat(knoData[0].retan !== null && !isNaN(knoData[0].retan) ? knoData[0].retan : 0)
                                        + parseFloat(knoData[0].medi !== null && !isNaN(knoData[0].medi) ? knoData[0].medi : 0)
                                        + parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? knoData[0].advkapat : 0)
                                        + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? knoData[0].ratibkapat : 0)
                                        + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? knoData[0].khadyakapat : 0)
                                        + parseFloat(knoData[0].karjhpta !== null && !isNaN(knoData[0].karjhpta) ? knoData[0].karjhpta : 0)
                                        + parseFloat(knoData[0].karjintr !== null && !isNaN(knoData[0].karjintr) ? knoData[0].karjintr : 0)
                                        + parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) + parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) //+ parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0)


                                    {
                                        localStorage.getItem("billtype") === "oldbill" ?
                                            tyene = parseFloat(knoData[0].newadv !== null && !isNaN(knoData[0].newadv) ? knoData[0].newadv : 0) + parseFloat(knoData[0].newkhadya !== null && !isNaN(knoData[0].newkhadya) ? knoData[0].newkhadya : 0) + parseFloat(knoData[0].newratib !== null && !isNaN(knoData[0].newratib) ? knoData[0].newratib : 0)
                                            :
                                            tyene = '0';
                                    }

                                    ada = parseFloat(parseFloat(sumOfFifthTable) - parseFloat(tkapat) + parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? (parseFloat(knoData[0].vah)) : 0) + parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? (parseFloat(knoData[0].comm)) : 0)).toFixed(2);

                                    const totalAmt = tableDataWithZeros.reduce((total, entry) => total + parseFloat(entry.amt), 0);

                                    dateflag = "";
                                    bothornot = "";

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";

                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "not";
                                        if (type == 'Buffalo') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    // Remaining combinations

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn == null) {
                                        //
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn == null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn != null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor != null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 0;
                                        bothornot = "both";
                                        return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor == null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }
                                    }

                                    if (tlitermhmor == null && tlitermhevn == null && tlitergaymor != null && tlitergayevn != null) {
                                        dateflag = 2;
                                        bothornot = "not";
                                        if (type == 'Cow') {
                                            return renderTable(tableDataWithZeros, tableIndex, totalLiter, avgfat, avgsnf, totalAmt, typeTimeKey, dateflag, bothornot, avgrate);
                                        }

                                    }

                                })
                            }

                            {/* ✅ NEW: Total Liter column (like Amount column) */}
                            {/* ✅ NEW: Total Liter + Amount columns */}
                            <View style={styles.lastTwoWrap}>

                                {/* ---- Liter summary ---- */}
                                <View style={bothornot === "both" ? styles.summaryLiterBoth : styles.summaryLiterSingle}>
                                    <View style={styles.summaryHeaderRowliter}>
                                        <Text style={styles.summaryHeaderCell}>{t("common.liter")}</Text>
                                    </View>
                                    {sumsOfLiterColumns.map((sum, entryIndex) => (
                                        <View key={entryIndex} style={styles.summaryDataRow}>
                                            <Text style={bothornot === "both" ? styles.summaryDataCellliter : styles.summaryDataCelllitersingle}>{parseFloat(sum).toFixed(2)}</Text>
                                        </View>
                                    ))}

                                    <View style={styles.summaryTotalRowliter}>
                                        <Text style={bothornot === "both" ? styles.summaryTotalCell : styles.summaryTotalCellsingle}>{sumOfLiterTable}</Text>
                                    </View>
                                </View>

                                {/* ---- Amount summary ---- */}
                                <View style={bothornot === "both" ? styles.summaryAmtBoth : styles.summaryAmtSingle}>
                                    <View style={bothornot === "both" ? styles.summaryHeaderRow : styles.summaryHeaderRowsingle}>
                                        <Text style={bothornot === "both" ? styles.summaryHeaderCell : styles.summaryHeaderCell}>
                                            {t("common.amount")}
                                        </Text>
                                    </View>
                                    {sumsOfAmtColumns.map((sum, entryIndex) => (
                                        <View key={entryIndex} style={styles.summaryDataRow}>
                                            <Text style={bothornot === "both" ? styles.summaryDataCell : styles.summaryDataCellsingle}>{parseFloat(sum).toFixed(2)}</Text>
                                        </View>
                                    ))}

                                    <View style={bothornot === "both" ? styles.summaryTotalRow : styles.summaryTotalRowsingle}>
                                        <Text style={bothornot === "both" ? styles.summaryTotalCell : styles.summaryTotalCellsingle}>{sumOfFifthTable}</Text>
                                    </View>
                                </View>

                            </View>

                        </View>


                        {localStorage.getItem("design") === "1" ? (
                            <View style={styles.row}>
                                <View style={styles.column2}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint.deposit")}</Text>
                                </View>
                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint.advance")}</Text>
                                </View>
                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint.khady")}</Text>
                                </View>
                                <View style={styles.column1}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint.ratib")}</Text>
                                </View>
                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>-</Text>
                                </View>
                                <View style={styles.column3}>
                                    <Text style={styles.column1Labelcenter2}>{t("billprint.bill")}</Text>
                                </View>
                            </View>
                        ) : (
                            ""
                        )}

                        <View style={styles.row}>
                            {/* ठेव */}

                            <View style={localStorage.getItem("design") === "1" ? styles.column2 : styles.column2noborder}>

                                {localStorage.getItem("showthev") === "Yes" ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.depositBox.prev")}</Text>
                                            <Text style={styles.column1Value}>
                                                {knoData[0].mthev !== null && !isNaN(knoData[0].mthev)
                                                    ? parseFloat(knoData[0].mthev).toFixed(2)
                                                    : 0}
                                            </Text>
                                        </View>
                                    ) : (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.depositBox.prev")}</Text>
                                            <Text style={styles.column1Value}>
                                                {parseFloat(localStorage.getItem("bcount")) > 0
                                                    ? (knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0)
                                                    : (knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0)}
                                            </Text>
                                        </View>
                                    )
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {knoData[0].cthev !== null && !isNaN(knoData[0].cthev) ? knoData[0].cthev : 0}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.depositBox.deduct")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(
                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}

                                {localStorage.getItem("showthev") === "Yes" ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.depositBox.total")}</Text>
                                            <Text style={styles.column1Value}>
                                                {(
                                                    (!isNaN(parseFloat(knoData[0].newthev)) ? parseFloat(knoData[0].newthev) : 0)
                                                ).toFixed(2)}
                                            </Text>
                                        </View>
                                    ) : (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.depositBox.total")}</Text>
                                            <Text style={styles.column1Value}>
                                                {(
                                                    parseFloat(localStorage.getItem("bcount")) > 0
                                                        ? parseFloat(knoData[0].newthev !== null && !isNaN(knoData[0].newthev) ? knoData[0].newthev : 0) +
                                                        parseFloat(
                                                            parseFloat(
                                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                                            ).toFixed(2)
                                                        )
                                                        : parseFloat(knoData[0].othev !== null && !isNaN(knoData[0].othev) ? knoData[0].othev : 0) +
                                                        parseFloat(
                                                            parseFloat(
                                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev)
                                                            ).toFixed(2)
                                                        )
                                                ).toFixed(2)}
                                            </Text>
                                        </View>
                                    )
                                ) : (
                                    ""
                                )}
                            </View>


                            {/* एड्व्हांस  */}
                            {
                                localStorage.getItem("design") === "1" ?
                                    <>
                                        <View style={styles.column1}>
                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.prev")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(localStorage.getItem("bcount")) > 0 ? knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0 : knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View> :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}> {kapat[kno] && !isNaN(kapat[kno].cuchal) ? parseFloat(kapat[kno].cuchal).toFixed(2) : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].newadv) || 0)
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            parseFloat(localStorage.getItem("bcount")) > 0 ?
                                                                (parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? knoData[0].madv : 0) + parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) - parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                                :
                                                                (parseFloat(knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0) + parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) - parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            }
                                        </View>

                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>{knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? parseFloat(knoData[0].mkhadya).toFixed(2) : 0}</Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}> {kapat[kno] && !isNaN(kapat[kno].ckhadya) ? parseFloat(kapat[kno].ckhadya).toFixed(2) : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].newkhadya) || 0)
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) + parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) - parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0))
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                            }
                                        </View>

                                        <View style={styles.column1}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.commonBox.prev")}</Text>
                                                <Text style={styles.column1Value}>{knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? parseFloat(knoData[0].mratib).toFixed(2) : 0}</Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.on")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.deduct")}</Text>
                                                    <Text style={styles.column1Value}> {kapat[kno] && !isNaN(kapat[kno].ratibkapat) ? parseFloat(kapat[kno].ratibkapat).toFixed(2) : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {(
                                                            (parseFloat(knoData[0].newratib) || 0)
                                                        ).toFixed(2)}
                                                    </Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.commonBox.balance")}</Text>
                                                </View>
                                            }
                                        </View>
                                    </>
                                    :
                                    <>
                                        <View style={styles.column1noborder}>
                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) + parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) + parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)).toFixed(2)}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.prevBalance")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(localStorage.getItem("bcount")) > 0 ? parseFloat(parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) + parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0)).toFixed(2) : knoData[0].obal !== null && !isNaN(knoData[0].obal) ? knoData[0].obal : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.khadyOn")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.khadyOnN")}</Text>
                                                    <Text style={styles.column1Value}>{knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.advanceOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View> :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.advanceOnN")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0).toFixed(2)}</Text>
                                                </View>
                                            }

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.ratibOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0).toFixed(2)}</Text>
                                                </View> :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.ratibOn")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0).toFixed(2)}</Text>
                                                </View>
                                            }
                                        </View>

                                        <View style={styles.column1noborder}>
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.summaryBox.totalBalance")}</Text>
                                                <Text style={styles.column1Value}>{parseFloat(parseFloat(parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) + parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) + parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)) + parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) + parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) + parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)).toFixed(2)}</Text>
                                            </View>

                                            {localStorage.getItem("billtype") === "oldbill" ?
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.directDeduct")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)).toFixed(2)}</Text>
                                                </View>
                                                :
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.summaryBox.directDeduct")}</Text>
                                                    <Text style={styles.column1Value}>{parseFloat(parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0)).toFixed(2)}</Text>
                                                </View>
                                            }

                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{t("billprint.summaryBox.dueBalance")}</Text>
                                                <Text style={styles.column1Value}>{parseFloat(parseFloat(parseFloat(parseFloat(knoData[0].madv !== null && !isNaN(knoData[0].madv) ? parseFloat(knoData[0].madv).toFixed(2) : 0) + parseFloat(knoData[0].mkhadya !== null && !isNaN(knoData[0].mkhadya) ? knoData[0].mkhadya : 0) + parseFloat(knoData[0].mratib !== null && !isNaN(knoData[0].mratib) ? knoData[0].mratib : 0)) + parseFloat(knoData[0].ckhadya !== null && !isNaN(knoData[0].ckhadya) ? knoData[0].ckhadya : 0) + parseFloat(knoData[0].cadv !== null && !isNaN(knoData[0].cadv) ? knoData[0].cadv : 0) + parseFloat(knoData[0].cratib !== null && !isNaN(knoData[0].cratib) ? knoData[0].cratib : 0)) - parseFloat(parseFloat(knoData[0].advkapat !== null && !isNaN(knoData[0].advkapat) ? parseFloat(knoData[0].advkapat).toFixed(2) : 0) + parseFloat(knoData[0].khadyakapat !== null && !isNaN(knoData[0].khadyakapat) ? parseFloat(knoData[0].khadyakapat).toFixed(2) : 0) + parseFloat(knoData[0].ratibkapat !== null && !isNaN(knoData[0].ratibkapat) ? parseFloat(knoData[0].ratibkapat).toFixed(2) : 0))).toFixed(2)}</Text>
                                            </View>
                                        </View>
                                    </>
                            }



                            {/* एकूण */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint.totalBox.liter")}</Text>
                                    <Text style={styles.column1Value}>{totalOfTotalLiter.toFixed(2)}</Text>
                                </View>

                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint.totalBox.yene")}</Text>
                                    <Text style={styles.column1Value}>{tyene.toFixed(2)}</Text>
                                </View>

                                {localStorage.getItem("showother") === "Yes" ? (
                                    <>
                                        {parseFloat(knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0) > 0 ? (
                                            localStorage.getItem("billtype") === "oldbill" ? (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.totalBox.otherDeductPerLiter")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter) ? parseFloat(knoData[0].ikapatliter) : 0}
                                                    </Text>
                                                </View>
                                            ) : (
                                                <View style={styles.column1Row}>
                                                    <Text style={styles.column1Label}>{t("billprint.totalBox.otherDeductPerLiterN")}</Text>
                                                    <Text style={styles.column1Value}>
                                                        {knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0}
                                                    </Text>
                                                </View>
                                            )
                                        ) : (
                                            ""
                                        )}

                                        {parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill) : 0) > 0 ? (
                                            <View style={styles.column1Row}>
                                                <Text style={styles.column1Label}>{localStorage.getItem("itrmainname")}</Text>
                                                <Text style={styles.column1Value}>
                                                    {knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0}
                                                </Text>
                                            </View>
                                        ) : (
                                            ""
                                        )}
                                    </>
                                ) : (
                                    ""
                                )}
                            </View>


                            {/* बिल */}
                            <View style={localStorage.getItem("design") === "1" ? styles.column3 : styles.column3noborder}>
                                <View style={styles.column1Row}>
                                    <Text style={styles.column1Label}>{t("billprint.billBox.totalBill")}</Text>
                                    <Text style={styles.column1Value}>{sumOfFifthTable}</Text>
                                </View>

                                {parseFloat(knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah) : 0) > 0 ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.billBox.transportPlus")}</Text>
                                            <Text style={styles.column1Value}>
                                                {knoData[0].vah !== null && !isNaN(knoData[0].vah) ? parseFloat(knoData[0].vah).toFixed(2) : 0}
                                            </Text>
                                        </View>
                                    ) : (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.billBox.transportPerLiterN")}</Text>
                                            <Text style={styles.column1Value}>
                                                {knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                    ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                    : 0}
                                            </Text>
                                        </View>
                                    )
                                ) : (
                                    ""
                                )}

                                {parseFloat(knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm) : 0) > 0 ? (
                                    localStorage.getItem("billtype") === "oldbill" ? (
                                        <View style={styles.column1Row}>
                                            <Text style={styles.column1Label}>{t("billprint.billBox.commissionPlus")}</Text>
                                            <Text style={styles.column1Value}>
                                                {knoData[0].comm !== null && !isNaN(knoData[0].comm) ? parseFloat(knoData[0].comm).toFixed(2) : 0}
                                            </Text>
                                        </View>
                                    ) : (
                                        ""
                                    )
                                ) : (
                                    ""
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.billBox.totalDeduct")}</Text>
                                        <Text style={styles.column1Value}>{parseFloat(tkapat).toFixed(2)}</Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Row}>
                                        <Text style={styles.column1Label}>{t("billprint.billBox.totalDeductN")}</Text>
                                        <Text style={styles.column1Value}>
                                            {parseFloat(
                                                parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                parseFloat(
                                                    knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                        ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                        : 0
                                                ) +
                                                parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                parseFloat(
                                                    knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                        ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                        : 0
                                                )
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}

                                {localStorage.getItem("billtype") === "oldbill" ? (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprint.billBox.netPayableOld")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(ada).toFixed(localStorage.getItem("round") === "on" ? 0 : 2)}
                                        </Text>
                                    </View>
                                ) : (
                                    <View style={styles.column1Rowgray}>
                                        <Text style={styles.column1Label}>{t("billprint.billBox.netPayableN")}</Text>
                                        <Text style={parseFloat(ada) >= 0 ? styles.tableCellgreen : styles.tableCellred}>
                                            {parseFloat(
                                                parseFloat(sumOfFifthTable) -
                                                parseFloat(
                                                    parseFloat(knoData[0].mhliter * knoData[0].mhthev) +
                                                    parseFloat(knoData[0].gayliter * knoData[0].gaythev) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].cuchal) ? kapat[kno].cuchal : 0) +
                                                    parseFloat(kapat[kno] && !isNaN(kapat[kno].ckhadya) ? kapat[kno].ckhadya : 0) +
                                                    parseFloat(
                                                        knoData[0].ikapatliter !== null && !isNaN(knoData[0].ikapatliter)
                                                            ? parseFloat(parseFloat(knoData[0].ikapatliter) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    ) +
                                                    parseFloat(knoData[0].ikapatbill !== null && !isNaN(knoData[0].ikapatbill) ? parseFloat(knoData[0].ikapatbill).toFixed(2) : 0) +
                                                    parseFloat(
                                                        knoData[0].mhvah !== null && !isNaN(knoData[0].mhvah)
                                                            ? parseFloat(parseFloat(knoData[0].mhvah) * parseFloat(totalOfTotalLiter)).toFixed(2)
                                                            : 0
                                                    )
                                                ).toFixed(2)
                                            ).toFixed(2)}
                                        </Text>
                                    </View>
                                )}
                            </View>

                        </View>

                        {localStorage.getItem("design") === "2" ?
                            <View style={styles.line} /> : ''}

                        <View style={styles.imagerow}>
                            <View style={styles.simplerow}>
                                <Text style={styles.imgtext}>{t("billprint.footer.poweredBy")}</Text>
                                <Image style={styles.image} src={Logo} />
                            </View>
                            <Text style={styles.imgtext}>
                                {t("billprint.footer.contact", { phone: "800-788-9200" })}
                            </Text>
                        </View>

                        {index < Object.keys(data).length - 1 && <Text style={styles.pageBreak} />}

                    </View>)}
            </Page>

        </>
    );

}

export default Billprint;
